<template>
    <div>
        <a-modal
          v-if="!isNewPic"
          wrapClassName="customModal bindDeviceClass qrCodeClass"
          centered
          :maskClosable="false"
          :closable="false"
          v-model="qrcodeModel"
        >
            <template slot="title"> </template>
            <div class="room-info">
                <p class="tit">教室二维码</p>
                <img
                  class="close-icon ZHIHUISHU_QZMD"
                  @click="afterClose"
                  src="~@/assets/img/close@2x.png"
                  width="26"
                  height="26"
                />
                <div class="qr-bg">
                    <p class="text">
                        <span>“知到-教师版”APP扫码</span>
                        <span>开启教室设备</span>
                    </p>
                    <img :src="currentRoomData.qrAddress" alt="" width="144" height="144">
                    <p style="line-height: 17px">{{ currentRoomData.roomName }}</p>
                </div>
            </div>
            <template slot="footer">
                <div class="download-btn ZHIHUISHU_QZMD" @click="downloadQR">
                    <a-icon type="download" />
                    <span>下载二维码</span>
                </div>
            </template>
        </a-modal>
        <a-modal
          v-if="isNewPic"
          wrapClassName="customModal bindDeviceClass qrCodeClass qrCodeNoBg"
          centered
          :maskClosable="false"
          :closable="false"
          v-model="qrcodeModel"
          @ok="handleBindDevice"
        >
            <template slot="title"> </template>
            <div class="room-info new-info">
                <p class="tit">教室二维码</p>
                <img
                  class="close-icon ZHIHUISHU_QZMD"
                  @click="afterClose"
                  src="~@/assets/img/close@2x.png"
                  width="26"
                  height="26"
                />
                <img
                  :src="currentRoomData.qrAddress"
                  width="260"
                  height="368"
                  style="border-radius: 6px;"
                  alt=""
                >
            </div>
            <template slot="footer">
                <div class="download-btn2 ZHIHUISHU_QZMD" @click="downloadQR">
                    <img src="@/assets/img/downlond.png" alt="">
                    <span>下载</span>
                </div>
            </template>
        </a-modal>
    </div>
     
</template>

<script>
export default {
    props: {
        showQrcodeModelProp: {
            type: Boolean,
            default: false
        },
        currentRoomData: {
            type: Object
        },
        isNewPic: {
            type: Boolean
        }
    },
    watch: {
        showQrcodeModelProp(val, old) {
            this.qrcodeModel = val
            if (val == true) {
            }
        }
    },
    data() {
        return {
            qrcodeModel: false,
        }
    },
    methods: {
        afterClose() {
            this.$emit("update:showQrcodeModelProp", false)   
        },
        downloadQR() {
            let a = document.createElement('a')
            a.download = this.currentRoomData.roomName + '教室二维码.png'
            this.downloadIamge(this.currentRoomData.qrAddress, a.download)
        },
        downloadIamge(imgsrc, name) {
            var image = new Image()
            image.setAttribute("crossOrigin", "anonymous")
            image.onload = function() {
                var canvas = document.createElement("canvas")
                canvas.width = image.width
                canvas.height = image.height
                var context = canvas.getContext("2d")
                context.drawImage(image, 0, 0, image.width, image.height)
                var url = canvas.toDataURL("image/png")

                var a = document.createElement("a")
                var event = new MouseEvent("click")
                a.download = name || "photo"
                a.href = url
                a.dispatchEvent(event)
            };
            image.src = imgsrc
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep .qrCodeClass {

    .ant-modal {
      width: 420px !important;
      height: 496px;
      padding-bottom: 0;
      .ant-modal-content {
        position: relative;
        background: url('~@/assets/img/bg@2x.png') no-repeat;
        background-size: contain;
        height: 496px;
        .room-info {
          margin-bottom: 20px;
          text-align: center;
          .tit {
            padding-top: 16px;
            font-size: 22px;
            font-weight: bold;
          }
          .close-icon {
            position: absolute;
            top: 40px;
            right: 40px;
            cursor: pointer;
          }
          .qr-bg {
            margin: 24px auto 0;
            width: 249px;
            height: 310px;
            background: #3db166;
            border-radius: 6px;
            color: #fff;
            img {
              margin: 30px 0 25px;
            }
            .text {
              padding-top: 30px;
              font-size: 18px;
              display: flex;
              flex-direction: column;
            }
          }
        }
        .download-btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 134px;
          height: 32px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #ededed;
          cursor: pointer;
        }
        .new-info{
          margin-bottom: 0;
          .tit{
            padding-top: 18px;
            padding-bottom: 18px;
            line-height: 1;
          }
          .close-icon{
            top: 20px;
            right: 16px;
          }
        }
        .download-btn2{
          width: 104px;
          height: 38px;
          border-radius: 4px;
          border: 1px solid #5F60D3;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 14px 0 20px 0;
          img{
            width: 20px;
            height: 20px;
            margin-right: 8px;
          }
          span{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #5F60D3;
          }
        }
      }
      .ant-modal-body {
        padding: 24px 24px 0;
      }
      .ant-modal-footer {
        border-top: none;
        display: flex;
        justify-content: center;
      }
    }
}
</style>